import { render, staticRenderFns } from "./DueDate.vue?vue&type=template&id=537ebc3f&scoped=true"
import script from "./DueDate.vue?vue&type=script&lang=js"
export * from "./DueDate.vue?vue&type=script&lang=js"
import style0 from "./DueDate.vue?vue&type=style&index=0&id=537ebc3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537ebc3f",
  null
  
)

export default component.exports